import { AsyncPipe, NgClass, NgIf, TitleCasePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

import { OrderService } from '../../../core/providers/order/order.service';
import { InCartLabelComponent } from '../../../shared/components/in-cart-label/in-cart-label.component';
import { FormatPricePipe } from '../../../shared/pipes/format-price.pipe';
import { GetProductDetailQuery, GetProductVariantDetailQuery } from '../../common/gql/graphql';
import { AddToWishlistButtonComponent } from '../add-to-wishlist-button/add-to-wishlist-button.component';
import { LargeLetterLabelComponent } from '../large-letter-label/large-letter-label.component';
import { SpecialPriceBadgeComponent } from '../special-price-badge/special-price-badge.component';
import { StockLevelLabelComponent } from '../stock-level-label/stock-level-label.component';
import { QuantityInputComponent } from '../../../shared/components/quantity-input/quantity-input.component';

@Component({
    selector: 'kb-selected-variant-controls',
    templateUrl: './selected-variant-controls.component.html',
    styleUrls: ['./selected-variant-controls.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        StockLevelLabelComponent,
        FormsModule,
        NgClass,
        FontAwesomeModule,
        InCartLabelComponent,
        AsyncPipe,
        TitleCasePipe,
        FormatPricePipe,
        SpecialPriceBadgeComponent,
        LargeLetterLabelComponent,
        AddToWishlistButtonComponent,
        QuantityInputComponent,
    ],
})
export class SelectedVariantControlsComponent implements OnChanges {
    @Input() selectedVariant:
        | NonNullable<GetProductDetailQuery['product']>['variants'][number]
        | NonNullable<GetProductVariantDetailQuery['productVariant']>;
    @Input() inCartQty: number;
    @Input() adjustedQty: { [variantId: string]: number };
    @Input() selectOptionLabel = 'Select an option';
    @Input() qualifiesForLetterboxService = false;
    @Input() inWishlists: Array<{ id: string; name?: string }> | undefined;

    @Output() addToCartClick = new EventEmitter<{ productVariantId: string; quantity: number }>();
    @Output() addToWishlistClick = new EventEmitter<{ productVariantId: string; wishlistId?: string }>();
    @Output() setQuantity = new EventEmitter<number>();
    @Output() addToCartHover = new EventEmitter<void>();
    rrp: number | undefined;
    rrpPercent: number | undefined;

    qty = 1;
    state$: Observable<'processing' | 'ready'>;
    minus = faMinus;
    plus = faPlus;

    constructor(orderService: OrderService) {
        this.state$ = orderService.processing$.pipe(
            map((processing) => (processing ? 'processing' : 'ready')),
            startWith('ready' as any),
        );
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.selectedVariant) {
            const { rrp } = this.selectedVariant?.customFields ?? {};
            this.rrp = rrp && this.selectedVariant.priceWithTax < rrp ? rrp : undefined;
            this.rrpPercent = this.rrp
                ? Math.round((1 - this.selectedVariant.priceWithTax / this.rrp) * 100)
                : undefined;
        }
    }
}
